module.exports = __webpack_public_path__ + "static/media/Defense.f5767f54.png";